import { fetchPartners } from '../api';
import { Env } from '@/shared/config/environment';

const state = {
  partnersList: [],
  isLoadingPartners: false,
  error: null,
};

const mutations = {
  SET_PARTNERS_LIST(state, partnersList) {
    state.partnersList = partnersList;
  },
  SET_LOADING(state, isLoadingPartners) {
    state.isLoading = isLoadingPartners;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

const actions = {
  async fetchPartners({ commit, dispatch }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);

    try {
      const partners = await fetchPartners();
      commit('SET_PARTNERS_LIST', partners);

      return partners;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Помилка при отриманні списку партнерів';

      commit('SET_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити список партнерів',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

const getters = {
  getPartnersList: (state) => state.partnersList,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
